import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useParent } from '../../contexts/parentContext';
import ChildControlFull from './ChildControlFull';
import ChildControlEvents from './ChildControlEvents';
import ChildControlFeed from './ChildControlFeed';
import ChildControlTeam from './ChildControlTeam';

const ChildControl = () => {
  const { view } = useParams();
  const { selectedChild } = useParent();

  console.log('🔍 ChildControl - view:', view);
  console.log('🔍 ChildControl - selectedChild:', selectedChild);

  if (!selectedChild) {
    console.log('❌ ChildControl - No selectedChild, showing selection message');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">No Child Selected</h2>
          <p className="text-gray-600 mb-4">Please select a child first.</p>
          <Link 
            to="/parent/children"
            className="px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
          >
            Select Child
          </Link>
        </div>
      </div>
    );
  }

  console.log('✅ ChildControl - selectedChild exists, rendering view:', view);

  switch (view) {
    case 'full':
      return <ChildControlFull />;
    case 'events':
      return <ChildControlEvents />;
    case 'feed':
      return <ChildControlFeed />;
    case 'team':
      return <ChildControlTeam />;
    default:
      return <ChildControlFull />;
  }
};

export default ChildControl; 